import script from "./ApiConnectionNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiConnectionNotice.vue?vue&type=script&setup=true&lang=js"

import "./ApiConnectionNotice.vue?vue&type=style&index=0&id=809d27d2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-809d27d2"]])

export default __exports__